import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useState } from 'react';
import Divider from '@mui/material/Divider';

interface SearchBoxProps {
  handleSubmit: (inputValue: string) => void;
  handleClearAll: () => void;
  placeholder: string;
}

export default function SearchBox({ handleSubmit, handleClearAll, placeholder }: SearchBoxProps) {
  const [inputValue, setInputValue] = useState('');

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleSubmit(inputValue);
  };

  const handleFormClear = (event: any) => {
    event.preventDefault();
    setInputValue('');
    handleClearAll();
  };

  return (
    <Paper
      component="form"
      sx={{ p: '4px 4px', display: 'flex', alignItems: 'center', width: 400 }}
      onSubmit={handleFormSubmit}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        slotProps={{ input: { 'aria-label': 'search google maps' } }}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
        <SearchIcon />
      </IconButton>
      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions" onClick={handleFormClear}>
        <ClearIcon />
      </IconButton>
    </Paper>
  );
}
